import './Contact.css';
import githubLogo from './images/github.svg';
import linkedinLogo from './images/linked-in.svg';
import mailLogo from './images/mail.svg';
import cvlogo from './images/cv.svg';

function Contact() {
  return (
    <div className="contact">
      <h2>Contact</h2>
      <div className="social-media">
        <a href="mailto:contact@fabiantrejo.com">
          <img src={mailLogo} alt="" aria-hidden="true" />
          <span className="social-label">Mail</span>
        </a>
        <a href="https://www.linkedin.com/in/fabiantrejo/" target="_blank" rel="noopener noreferrer">
          <img src={linkedinLogo} alt="" aria-hidden="true" />
          <span className="social-label">LinkedIn</span>
        </a>
        <a href="https://github.com/CracklyDuck" target="_blank" rel="noopener noreferrer">
          <img src={githubLogo} alt="" aria-hidden="true" />
          <span className="social-label">GitHub</span>
        </a>
        <a href="/Fabian_Trejo_Resume.pdf" target="_blank" rel="noopener noreferrer">
          <img src={cvlogo} alt="" aria-hidden="true" />
          <span className="social-label">Resume</span>
        </a>
      </div>
    </div>
  );
}

export default Contact;